<template>
  <modal
    class="addNewRetainershipModal"
    name="addDriverModal"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closeModal"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="mt-2 add__retainership__header">
          <span>
            <img src="@/assets/img/Group 484.png" width="50px" />
          </span>
          {{ $t("text.drivers.addDriver") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="row">
              <div class="col-md-6">
                <div class="mt-3 form_input_section">
                  <div class="input__block" ref="name_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.drivers.driversName')"
                      class="form-control w-100"
                      v-model="name"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mt-3 form_input_section">
                  <div class="input__block" ref="phone_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.drivers.phoneNumber')"
                      class="form-control w-100"
                      v-model="phone"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mt-3 form_input_section">
                  <div class="input__block" ref="email_input_div">
                    <input
                      type="email"
                      :placeholder="$t('text.drivers.email')"
                      class="form-control w-100"
                      v-model="email"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mt-3 form_input_section">
                  <div class="input__block" ref="address_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.drivers.address')"
                      class="form-control w-100"
                      v-model="address"
                    />
                  </div>
                  <div ref="address_error_message"></div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="mt-3 form_input_section">
                  <div class="mt-3 input__block" ref="state_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.drivers.state')"
                      class="form-control w-100"
                      v-model="state"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-5 text-center">
              <button
                class="btn dealers_btn"
                @click="createDriver($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.drivers.addDriver") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="19px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "addDriverModal",
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
      name: null,
      email: null,
      phone: null,
      address: null,
      state: null,
    };
  },
  created() {
    this.showLoader = true;
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeModal() {
      this.$modal.hide("addDriverModal");
    },
    createDriver($event) {
      $event.preventDefault();
      if (!this.name) {
        this.$toast.open({
          message: this.$t("text.errors.driverNameReq"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.phone) {
        this.$toast.open({
          message: this.$t("text.errors.contactPhoneMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (this.phone.length < 10 || this.phone.length > 13) {
        this.$toast.open({
          message: this.$t("text.errors.shortPhoneNumber"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      if (!this.address) {
        this.$toast.open({
          message: this.$t("text.drivers.addressMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.state) {
        this.$toast.open({
          message: this.$t("text.drivers.stateMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      let data = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        code: this.code,
        address: this.address,
        state: this.state,
      };
      this.isButtonDisabled = true;
      $(".loader").show();
      let _this = this;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Drivers/Create`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.closeModal();
          this.$toast.open({
            message: this.$t("text.drivers.successfullyAdded"),
            type: "success",
            duration: 3000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.name = null;
          this.email = null;
          this.phone = null;
          this.code = null;
          this.address = null;
          this.state = null;
          this.showLoader = false;
          this.$eventHub.$emit("fetchDrivers");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          $(".loader").hide();
        });
    },
  },
};
</script>
